import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

function Page({ title, children }) {
  useEffect(() => {
    const mvp = document.getElementById('meta-viewport');
    if (!mvp) {
      const meta = document.createElement('meta');
      meta.setAttribute('id', 'meta-viewport');
      meta.setAttribute('name', 'viewport');
      meta.setAttribute('content', 'width=device-width, initial-scale=1');
      meta.setAttribute('id', 'meta-viewport');
    } else {
      mvp.setAttribute('content', 'device-width, initial-scale=1');
    }
    return () => {
      if (mvp) {
        mvp.setAttribute('content', 'width=1284, initial-scale=1');
      }
    };
  }, []);

  return (
    <div className="auth-page">
      <Helmet>
        <title>{`${title} | SellerGeni`}</title>
      </Helmet>
      <Box className="responsiveHeight">{children}</Box>
    </div>
  );
}
Page.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default Page;
